module.exports = __webpack_public_path__ + "img/faq.d527a138.svg";